export const SELECTED_PRODUCT_TAB = 'SELECTED_PRODUCT_TAB';
export const BUY_PRODUCT = 'BUY_PRODUCT';

// Trial/license states:
export const NO_ACTION = 'NO_ACTION';
export const ACTIVE_INDIVIDUAL_TRIAL = 'ACTIVE_INDIVIDUAL_TRIAL';
export const ACTIVE_INSTITUTIONAL_TRIAL = 'ACTIVE_INSTITUTIONAL_TRIAL';
export const EXPIRED_TRIAL = 'EXPIRED_TRIAL';
export const ACTIVE_LICENSE = 'ACTIVE_LICENSE';
export const ACTIVE_ADMIN = 'ACTIVE_ADMIN';
export const INACTIVE_LICENSE = 'INACTIVE_LICENSE';
export const CANCELLED = 'CANCELLED';
export const SUSPENDED = 'SUSPENDED';
export const EXPIRING_SOON = 'EXPIRING_SOON';
